import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Header from './Components/Header';
import Footer from './Components/Footer';

import Home from './pages/Home';
import Aboutus from './pages/Aboutus';
import Services from './pages/Services';
import Industries from './pages/Industries';
import Careers from './pages/Careers';
import Contactus from './pages/Contactus';

const App = () => {
  return (
    <Router>
      <Header />
      
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<Aboutus />} />
        <Route path="/services" element={<Services />} />
        <Route path="/Industries" element={<Industries />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/contact" element={<Contactus />} />
      </Routes>

      <Footer />
    </Router>
  );
};

export default App;
